import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./HTMLInsertDialog.css";
import MultiSelectModal from "./MultiSelectModal";
import ImageDialog from "./ImageDialog";

import AlertModal from "./AlertModal";
import PromptModal from "./PromptModal";
import Common from "../../Common/Common";
import Place from "../../Models/Place";
import SectionsDialog from "./SectionsDialog";
import GoogleDrivePicker from "./GoogleDrivePicker";

// console.ignoredYellowBox = ["Warning: ..."];

class HTMLInserDialog extends Component {
  constructor(props) {
    super(props);
    let items = [
      {
        label: "HTML",
        value: "HTML",
        icon: () => <FontAwesomeIcon icon={solid("book-open-reader")}></FontAwesomeIcon>,
      },
      {
        label: "Itinerary",
        value: "Itinerary",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      //   { label: "Center", value: "Center", icon: () => < FontAwesomeIcon icon={solid("link")} ></> },
      //   { label: "New line", value: "New line", icon: () => < FontAwesomeIcon icon={solid("link")} ></> },
      //   {
      //     label: "Strike through",
      //     value: "Strike through",
      //     icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")} ></FontAwesomeIcon>,
      //   },
      {
        label: "Image",
        value: "Image",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      {
        label: "Map",
        value: "Map",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      {
        label: "Map with Places List",
        value: "Map with Places List",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },

      {
        label: "Places List",
        value: "Places List",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      {
        label: "Video",
        value: "Video",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      {
        label: "Audio",
        value: "Audio",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      //   {
      //     label: "Font Size & Color",
      //     value: "FontSize",
      //     icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")} ></FontAwesomeIcon>,
      //   },
      // {
      //   label: "Background Color",
      //   value: "Background Color",
      //   icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")} ></FontAwesomeIcon>,
      // },
      // {
      //   label: "Background Image",
      //   value: "Background Image",
      //   icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")} ></FontAwesomeIcon>,
      // },
    ];
    items = items.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    this.state = {
      insertType: "Image",
      linkType: "Image",
      htmlText: "",
      url: "",
      PlaceIds: [],
      PlaceNames: [],
      Places: [],
      GroupIds: [],
      GroupNames: [],
      Groups: [],
      CategoryIds: [],
      CategoryNames: [],
      Categories: [],
      OrderedPlaces: [],
      sectionName: "",
      guideID: "",
      mediaURL: "",
      imageURL: "",
      imageURLs: [],
      FontSize: "44",
      FontColor: "#000000",
      BackgroundColor: "#ffffff",
      BackgroundimageURL: null,
      imageSource: "Image",
      imageSize: "400",
      PickerItems: items,
      PickerValue: {
        label: "Image",
        value: "Image",
        icon: () => <FontAwesomeIcon FontAwesomeIcon icon={solid("link")}></FontAwesomeIcon>,
      },
      selectedImageSize: { id: "8", label: "400", value: "400", name: "400" },
      itineraryName: "Main",
      sectionLink: "",
      sectionName: "",

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
      ImageDialogShow: false,
      ImageDialogMulti: false,
      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],
      FilterOptions: [
        { name: "Show Only Favorites", value: "0", selected: false },
        { name: "Show Only Visited", value: "1", selected: false },
        { name: "Show Only Not Visited", value: "2", selected: false },
        { name: "Show Only Must See", value: "3", selected: false },
        { name: "Filter by Schedule", value: "4", selected: false },
        { name: "Filter by Day", value: "5", selected: false },
      ],
      ShowOnlyFavorites: false,
      ShowOnlyVisited: false,
      ShowOnlyNotVisited: false,
      ShowOnlyMustSee: false,
      ScheduleFilter: false,
      DayFilter: false,
      day: "",
      distanceFilter: -1,
      DistanceSelected: "",

      SectionsDialogShow: false,

      videoSource: "url",
      gdriveVideoFileId: "",
      gdriveVideoFileName: "",

      audioSource: "url",
      gdriveAudioFileId: "",
      gdriveAudioFileName: "",
    };
    this.handleChangeHTML = this.handleChangeHTML.bind(this);
    this.handleChangeURL = this.handleChangeURL.bind(this);
    this.handleChangeMediaURL = this.handleChangeMediaURL.bind(this);
  }

  componentDidMount() {}

  handleChangeURL = (event) => {
    this.setState({ ...this.state, url: event.target.value });
  };

  handleChangeHTML = (event) => {
    this.setState({ ...this.state, htmlText: event.target.value });
  };

  handleChangeMediaURL = (event) => {
    this.setState({ ...this.state, mediaURL: event.target.value });
  };

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };
  FilterOptionSelected = (index) => {
    let filters = this.state.FilterOptions.map((f, i) =>
      i === index ? { ...f, selected: !f.selected } : f
    );
    //this.setState({ FilterOptions: filters });
    //console.log("FilterOptionSelected", filters);

    let _DayFilter = this.FilterOptionChoosen("Filter by Day", filters);
    //SetFilterByDay(_FilterByDay);
    let _ScheduleFilter = this.FilterOptionChoosen("Filter by Schedule", filters);
    //SetFilterBySchedule(_FilterBySchedule);

    if (_DayFilter) filters = filters.filter((x) => x.name !== "Filter by Schedule");
    else if (_ScheduleFilter) filters = filters.filter((x) => x.name !== "Filter by Day");
    else {
      let index = filters.findIndex((x) => x.name === "Filter by Schedule");
      if (index === -1) filters.push({ name: "Filter by Schedule", value: "4", selected: false });
      index = filters.findIndex((x) => x.name === "Filter by Day");
      if (index === -1) filters.push({ name: "Filter by Day", value: "5", selected: false });
      console.log("FilterOptionSelected", filters);
    }

    filters = filters.sort((a, b) => (parseInt(a.value) > parseInt(b.value) ? 1 : -1));
    this.setState({ FilterOptions: filters, DayFilter: _DayFilter, ScheduleFilter: _ScheduleFilter });

    // setTimeout(() => {
    //   // CheckFilterOptions1();
    // }, 100);
  };

  FilterOptionChoosen = (name, options) => {
    const option = options.findIndex((x) => x.name === name && x.selected === true);
    if (option !== -1) return true;
    else return false;
  };

  AddHTML = () => {
    let placesList = [];
    if (this.state.OrderedPlaces.length != 0) {
      this.state.OrderedPlaces.forEach((place) => {
        placesList.push(place.value);
      });

      this.setState({ GroupIds: [], CategoryIds: [] });
    } else placesList = this.state.PlaceIds;

    let payload = {};
    //console.log("this.state.insertType", this.state.insertType);
    switch (this.state.insertType) {
      case "HTML":
        payload = { type: "html", html: this.state.htmlText };
        break;
      case "Itinerary":
        const Itinerary = window.guide_obj.createHTMLItinerary(this.state.itineraryName, null);
        payload = { type: "html", html: Itinerary };
        break;
      case "Section":
        let section = window.guide_obj.findSection(this.state.sectionLink);
        if (section == null) {
          this.MyAlert("section not found");
          return;
        }
        payload = { type: "html", html: section.html };
        break;
      case "Center":
        payload = { type: "html", html: `<p style="text-align:center;">${this.state.htmlText}</p><br>` };
        break;
      case "New line":
        payload = { type: "html", html: `<br>` };
        break;
      case "Strike through":
        payload = { type: "html", html: `<del>${this.state.htmlText}</del>` };
        break;
      case "Image":
        let image_html = "";
        let Image_url = this.state.mediaURL;
        if (Image_url.includes("https://drive.google.com")) {
          const video_parts = Image_url.split("/");
          Image_url = `https://docs.google.com/uc?export=download&id=${video_parts[5]}`;
          image_html = Place.createImageHTML(Image_url, null, null, this.state.imageSize);
        } else {
          image_html = Place.createImagesHTML(this.state.imageURLs, null, null, this.state.imageSize);
        }
        //let image_link = `<a href = imagelink:${Image_url}>${image_html}</a>`;
        //payload = { type: "html", html: image_link };
        payload = { type: "html", html: image_html };
        break;
      case "Map":
        //console.log("this.state.PlaceIds", placesList);
        payload = {
          type: "html",
          html: window.guide_obj.createMapHtml(placesList, this.state.GroupIds, this.state.CategoryIds, false),
        };
        break;
      case "Map with Places List":
        //console.log("this.state.PlaceIds", placesList);
        payload = {
          type: "html",
          html: window.guide_obj.createMapHtml(placesList, this.state.GroupIds, this.state.CategoryIds, true),
        };
        break;
      case "Places List":
        payload = {
          type: "html",
          html: window.guide_obj.getPlacesListHTML(placesList, this.state.GroupIds, this.state.CategoryIds, true),
        };
        break;
      case "Video":
        let video_html = "";
        if (this.state.videoSource === "gdrive") {
          if (!this.state.gdriveVideoFileId) { this.MyAlert("Select a video from Google Drive first"); return; }
          const gFileId = this.state.gdriveVideoFileId;
          video_html = `<iframe style="max-width: 100%; width: 640px; height: 480px;"
                          src="https://drive.google.com/file/d/${gFileId}/preview"
                          frameborder="0" allowfullscreen="allowfullscreen">
                        </iframe>`;
        } else {
          let video_url = this.state.mediaURL;
          if (video_url.includes("https://www.youtu") || video_url.includes("https://youtu")) {
            const youtube = video_url.split("/");
            let yvideo = youtube[youtube.length - 1];
            yvideo = yvideo.replace("watch?v=", "");
            video_html = `<iframe style="max-width: 100%; width: 640px; height: 480px;"
                            src="https://www.youtube.com/embed/${yvideo}?autoplay=0" frameborder="0" allowfullscreen="allowfullscreen">
                          </iframe>`;
          } else if (video_url.includes("https://drive.google.com")) {
            const video_parts = video_url.split("/");
            video_url = `https://docs.google.com/uc?export=download&id=${video_parts[5]}`;
            video_html = `<video width="640" height="480" controls>
                          <source src="${video_url}" type="video/mp4">
                            Video format not supported use mp4, WebM or Ogg.
                          </video>`;
          } else {
            let videoType = "video/mp4";
            if (video_url.toUpperCase().endsWith("MP4")) videoType = "video/mp4";
            else if (video_url.toUpperCase().endsWith("WEBM")) videoType = "video/webm";
            else if (video_url.toUpperCase().endsWith("OGG")) videoType = "video/ogg";
            video_html = `<video width="640" height="480" controls>
                            <source src="${video_url}" type="${videoType}">
                              Video format not supported use mp4, WebM or Ogg.
                          </video>`;
          }
        }
        payload = { type: "html", html: video_html };
        break;
      case "Audio":
        let audio_html = "";
        if (this.state.audioSource === "gdrive") {
          if (!this.state.gdriveAudioFileId) { this.MyAlert("Select an audio file from Google Drive first"); return; }
          const gAudioFileId = this.state.gdriveAudioFileId;
          audio_html = `<iframe style="max-width: 100%; width: 640px; height: 120px;"
                          src="https://drive.google.com/file/d/${gAudioFileId}/preview"
                          frameborder="0" allowfullscreen="allowfullscreen">
                        </iframe>`;
        } else {
          let audioType = "audio/mpeg";
          let audio_url = this.state.mediaURL;
          if (audio_url.startsWith("https://drive.google.com")) {
            const audio_parts = audio_url.split("/");
            audio_url = `https://docs.google.com/uc?export=download&id=${audio_parts[5]}`;
          }
          if (audio_url.toUpperCase().endsWith("WAV")) audioType = "audio/wav";
          else if (audio_url.toUpperCase().endsWith("OGG")) audioType = "audio/ogg";
          else if (audio_url.toUpperCase().endsWith("MP3")) audioType = "audio/mpeg";
          else audioType = "audio/mp4";
          audio_html = `<audio style="max-width: 100%; width: 600px;" controls="controls" controlsList="nodownload" autoplay>
    <source src="${audio_url}" type="${audioType}">
  Audio format not supported use mp3, wav, m4a or ogg.
  </audio>`;
        }
        payload = { type: "html", html: audio_html };
        break;
      case "Font Size & Color":
        const font_html = `<span style="font-size: ${this.state.FontSize}%; color: ${this.state.FontColor}; background-color: ${this.state.BackgroundColor}; !important; ">${this.state.htmlText}</span>`;
        //font_html = `<font size="${this.state.FontSize}">${this.state.htmlText}</font>`;
        payload = { type: "html", html: font_html };
        break;
      case "Background Color":
        payload = {
          type: "background-color",
          html: `<!--background-color: ${this.state.BackgroundColor}; background-color-->`,
        };
        break;
      case "Background Image":
        payload = {
          type: "background-image",
          html: `<!--background-image: url(${this.state.BackgroundimageURL}); background-size: 100% 100%; background-image-->`,
        };
        break;
      default:
        break;
    }
    //console.log(`${this.state.insertType}:`, payload);
    const callback = this.props.callback;
    if (callback == null) {
      console.log("No callback from InsertDialog");
      return;
    }
    callback({ type: this.state.insertType, payload: payload });
    this.props.onHide();
  };

  selectItinerary = () => {
    const schedules = window.guide_obj.schedule.geScheduleNames();
    this.MultiSelect(
      schedules,
      [{ label: this.state.itineraryName, value: this.state.itineraryName }],
      "uni",
      this.selectItineraryCallBack,
      "Select Itinerary"
    );
  };

  selectItineraryCallBack = (itineraries) => {
    //console.log("selectScheduleCallBack", itineraries[0].label);
    if (itineraries.length > 0)
      this.setState({
        itineraryName: itineraries[0].label,
        linkText: itineraries[0].label,
        linkTextDisplayed: itineraries[0].label,
      });
  };
  //   selectItinerary = () => {
  //     this.props.navigation.navigate("MultiSelectDialog", {
  //       selectionList: this.state.Itineraries,
  //       selectedItems: [{ label: this.state.itineraryName, value: this.state.itineraryName }],
  //       mode: "uni",
  //       callBack: this.selectItineraryCallBack,
  //       title: "Itinerary",
  //       selectText: "Select Itinerary",
  //     });
  //   };

  //   selectItineraryCallBack = (itineraries) => {
  //     //console.log("selectScheduleCallBack", itineraries[0].label);
  //     if (itineraries.length > 0) this.setState({ itineraryName: itineraries[0].label, linkText: itineraries[0].label });
  //   };

  selectSection = () => {
    //console.log("selectSection");
    this.setState({ SectionsDialogShow: true });
    //this.props.navigation.navigate("SectionSelect", { callback: this.selectSectionCallback });
  };

  selectSectionCallback = (section) => {
    let _sectionName = this.state.sectionName;
    if (_sectionName == "") _sectionName = section.Title;
    this.setState({ sectionLink: section.ID, sectionName: _sectionName });
  };

  displayList(arr) {
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += ", ";
      str += arr[i];
    }
    return str;
  }

  displayValueList(arr) {
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += ", ";
      str += arr[i].label;
    }
    return str;
  }

  selectPlaces = () => {
    this.MultiSelect(
      window.guide_obj.places.getPlacesToDisplay(null),
      this.state.Places,
      "multi",
      this.selectPlacesCallBack,
      "Places"
    );
  };

  selectPlacesCallBack = (Places) => {
    //console.log(Places);
    let placeIds = [];
    let placeNames = [];
    Places.forEach((place) => {
      placeIds.push(place.value);
      placeNames.push(place.label);
    });
    //console.log("placeIds", placeIds);
    this.setState({ Places: Places, PlaceIds: placeIds, PlaceNames: placeNames });
  };

  selectGroups = () => {
    let selectedGroups = [];
    let groups = this.state.Groups;
    groups.forEach((group) =>
      selectedGroups.push({
        label: group,
        value: group,
      })
    );
    this.MultiSelect(
      window.guide_obj.getGroupsToDisplay(null),
      selectedGroups,
      "multi",
      this.selectGroupsCallBack,
      "Select Groups"
    );
  };

  selectGroupsCallBack = (Groups) => {
    //console.log(Groups);
    let GroupIds = [];
    let GroupNames = [];
    Groups.forEach((group) => {
      GroupIds.push(group.value.id);
      GroupNames.push(group.label);
    });
    this.setState({ Groups: Groups, GroupIds: GroupIds, GroupNames: GroupNames });
    if (this.state.OrderedPlaces.length != 0) this.orderPlaces();
  };

  selectCategories = () => {
    //console.log("selectCategories");
    let selectedCategories = [];
    let cats = this.state.Categories;
    cats.forEach((cat) =>
      selectedCategories.push({
        label: cat.label,
        value: cat.value.id,
      })
    );
    this.MultiSelect(
      window.guide_obj.getCategoriesToDisplay(null),
      selectedCategories,
      "multi",
      this.selectCategoriesCallBack,
      "Select Categories"
    );
  };

  selectCategoriesCallBack = (Categories) => {
    let CategoryIds = [];
    let CategoryNames = [];
    Categories.forEach((cat) => {
      CategoryIds.push(cat.value.id);
      CategoryNames.push(cat.label);
    });
    this.setState({
      Categories: Categories,
      CategoryIds: CategoryIds,
      CategoryNames: CategoryNames,
    });
    if (this.state.OrderedPlaces.length != 0) this.orderPlaces();
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  selectLinkType = () => {
    //console.log("selectLinkType");
    this.MultiSelect(this.state.PickerItems, this.state.PickerValue, "uni", this.selectLinkTypeCallBack, "Link Type");
  };

  selectLinkTypeCallBack = (links) => {
    //console.log(links);
    if (links.length > 0) this.setState({ insertType: links[0].label, PickerValue: links[0] });
  };

  selectImageWidth = () => {
    //console.log("selectImageSize");
    const sizes = [
      { id: "1", label: "50", value: "50", name: "50" },
      { id: "2", label: "100", value: "100", name: "100" },
      { id: "3", label: "150", value: "150", name: "150" },
      { id: "4", label: "200", value: "200", name: "200" },
      { id: "5", label: "300", value: "300", name: "3000" },
      { id: "6", label: "400", value: "400", name: "400" },
      { id: "7", label: "500", value: "500", name: "500" },
      { id: "8", label: "600", value: "600", name: "600" },
      { id: "9", label: "700", value: "700", name: "700" },
      { id: "10", label: "800", value: "800", name: "800" },
      { id: "11", label: "900", value: "900", name: "900" },
      { id: "12", label: "1000", value: "1000", name: "1000" },
    ];
    // Was a leftover mobile-only this.props.navigation.navigate(...) call —
    // web has no React Navigation screen stack, so this silently did
    // nothing (or threw, caught invisibly) whenever a user tried to pick an
    // image width here. The MultiSelect(...) helper just below is the
    // SAME web-native modal pattern selectLinkType already uses correctly
    // in this very file. Found 2026-10-03.
    this.MultiSelect(sizes, this.state.selectedImageSize, "uni", this.selectImageWidthCallBack, "Image Size");
  };

  selectImageWidthCallBack = (sizes) => {
    //console.log(sizes);
    if (sizes.length > 0) this.setState({ imageSize: sizes[0].label, selectedImageSize: sizes[0] });
  };

  orderPlaces = () => {
    //console.log("orderPlaces");
    const places = window.guide_obj.getGroupAndCategoryPlaces(
      this.state.PlaceIds,
      this.state.GroupNames,
      this.state.CategoryNames
    );
    let list = [];
    let id = 0;
    for (let i = 0; i < places.length; i++) {
      list.push({
        id: (id++).toString(),
        name: places[i].Name,
        label: places[i].Name,
        value: places[i].ID,
      });
    }
    //console.log(list);
    this.props.navigation.navigate("OrderList", {
      list_items: list,
      callBack: this.orderPlacesCallBack,
    });
  };

  orderPlacesCallBack = (Places) => {
    //console.log(Places);
    this.setState({ OrderedPlaces: Places });
  };

  getImageURL = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Image URL",
      PromptModalMessage: "Enter Image URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.changeImageURL },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Image URL", value: this.state.imageURL }],
    });
  };

  changeImageURL = (inputs) => {
    if (inputs === null) return;
    this.setState({ imageURL: inputs[0].value });
  };

  selectImage = () => {
    console.log("selectImage");
    this.setState({
      ImageDialogShow: true,
      mode: "select",
      size: "medium",
      ImageDialogMulti: true,
      updateImage: this.updateImageCallBack,
    });
  };

  updateImageCallBack = (imageInfo) => {
    //("updateImageCallBack", imageInfo);
    if (imageInfo.length === 0) return;
    if (imageInfo[0].url_m !== "") this.setState({ imageURL: imageInfo[0].url_m, imageURLs: imageInfo });
    else this.setState({ imageURL: imageInfo[0].url, imageURLs: imageInfo });
  };

  selectBackgroundImage = () => {
    //console.log("selectImage");
    this.setState({
      ImageDialogShow: true,
      mode: "select",
      size: "medium",
      ImageDialogMulti: false,
    });
  };

  updateBackgroundImageCallBack = (imageInfo) => {
    this.setState({ BackgroundimageURL: imageInfo[0].url_m });
  };

  getImageURLString = (str) => {
    const url = Common.getImageURL(str, null, true);
    //console.log(url);
    return url;
  };

  selectAudio = () => {
    //console.log("selectAudio");
  };

  selectVideo = () => {
    //console.log("selectVideo");
  };

  selectGuide = () => {
    //console.log("selectGuide");
  };

  // selectSection = () => {
  //   //console.log("selectSection");
  // };

  selectFontSize = () => {
    let fontSizes = [];
    for (let i = 16; i < 97; i += 4) {
      fontSizes.push({
        label: `${i.toString()}%`,
        name: i.toString(),
        value: i.toString(),
      });
    }
    this.MultiSelect(fontSizes, [this.state.FontSize], "uni", this.selectFontSizeCallBack, "Font Size");
  };

  selectFontSizeCallBack = (fontSize) => {
    this.setState({ FontSize: fontSize[0].value });
  };

  selectFontColor = () => {
    this.props.navigation.navigate("ColorDialog", {
      initial_color: this.state.FontColor,
      callBack: this.selectFontColorCallBack,
    });
  };

  selectFontColorCallBack = (FontColor) => {
    this.setState({ FontColor: FontColor });
  };
  selectBackgroundColor = () => {
    this.props.navigation.navigate("ColorDialog", {
      initial_color: this.state.BackgroundColor,
      callBack: this.selectBackgroundColorCallBack,
    });
  };

  selectBackgroundColorCallBack = (FontColor) => {
    this.setState({ BackgroundColor: FontColor });
  };

  selectDay = () => {
    const days = window.guide_obj.getChooseDatesList(this.state.ScheduleName);
    this.MultiSelect(
      days,
      [{ label: this.state.day, value: this.state.day }],
      "uni",
      this.selectDayCallBack,
      "Select day"
    );
  };

  selectDayCallBack = (days) => {
    //console.log("FilterDatesCallBack", days);
    if (days.length > 0) this.setState({ day: days[0].label });
  };

  imageSourceMode = (value) => {
    this.setState({ imageSource: value });
  };

  changeImageSize = (size) => {
    //console.log("changeImageSize", size);
    this.setState({ imageSize: size.value });
  };

  closeModal = () => {
    console.log("closeModal");
    this.props.onHide();
  };

  UpdateDisplay = () => {};

  linkTypeChange = (event) => {
    console.log("linkTypeChange", event.target.value);
    this.state.PickerItems.forEach((item) => {
      if (item.label === event.target.value) this.selectLinkTypeCallBack([item]);
    });
  };

  render() {
    //console.log(this.state.Places);
    //console.log("text_color", text_color);
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );

    if (this.state.ImageDialogShow)
      return (
        <ImageDialog
          show={this.state.ImageDialogShow}
          onHide={() => this.setState({ ImageDialogShow: false })}
          user_info={this.props.user_info}
          // callback={this.updateImageCallBack}
          mode={"select"}
          modify_only={"true"}
          updateImage={this.updateImageCallBack}
          size={"sm"}
          multi={this.state.ImageDialogMulti}
          exif={false}
          folder={this.props.folder}
          setImageFolder={this.props.setImageFolder}
        />
      );

    return (
      <div style={{ zIndex: 65537 }}>
        <Modal
          {...this.props}
          size={window.innerWidth < 450 ? "lg" : "md"}
          dialogClassName="myModalClass hi-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable={false}
          onHide={this.closeModal}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="hi-shell">
              <div className="hi-header">
                <div className="hi-header-icon">
                  <FontAwesomeIcon icon={solid("file-code")} />
                </div>
                <span className="hi-title">Insert Content</span>
                <button className="hi-insert-btn" onClick={this.AddHTML}>Insert</button>
                <button className="hi-close" onClick={this.closeModal}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              <div className="hi-body">
                <div className="hi-field">
                  <span className="hi-label">Content type</span>
                  <select className="hi-select" onChange={this.linkTypeChange} defaultValue={this.state.insertType}>
                    <option value="Audio">Audio</option>
                    <option value="HTML">Custom HTML</option>
                    <option value="Image">Image</option>
                    <option value="Itinerary">Itinerary</option>
                    <option value="Map">Map</option>
                    <option value="Map with Places List">Map with Places List</option>
                    <option value="Places List">Places List</option>
                    <option value="Section">Section</option>
                    <option value="Video">Video</option>
                  </select>
                </div>

                {["Video"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">Source</span>
                    <div className="hi-btn-row">
                      <button
                        className={"hi-btn" + (this.state.videoSource === "url" ? " hi-btn-active" : "")}
                        onClick={() => this.setState({ videoSource: "url" })}
                      >
                        URL
                      </button>
                      <button
                        className={"hi-btn" + (this.state.videoSource === "gdrive" ? " hi-btn-active" : "")}
                        onClick={() => this.setState({ videoSource: "gdrive" })}
                      >
                        Google Drive
                      </button>
                    </div>
                  </div>
                )}

                {["Video"].includes(this.state.insertType) && this.state.videoSource === "url" && (
                  <div className="hi-field">
                    <span className="hi-label">URL</span>
                    <textarea
                      className="hi-textarea"
                      rows={4}
                      onChange={this.handleChangeMediaURL}
                      placeholder="Paste video URL here (YouTube or direct link)"
                    />
                  </div>
                )}

                {["Video"].includes(this.state.insertType) && this.state.videoSource === "gdrive" && (
                  <div className="hi-field">
                    {this.state.gdriveVideoFileId ? (
                      <div className="hi-btn-row">
                        <span className="hi-value" style={{ flex: 1 }}>{this.state.gdriveVideoFileName}</span>
                        <button
                          className="hi-btn"
                          onClick={() => this.setState({ gdriveVideoFileId: "", gdriveVideoFileName: "" })}
                        >
                          Change
                        </button>
                      </div>
                    ) : (
                      <GoogleDrivePicker
                        fileType="video"
                        onSelect={(items) => {
                          if (items.length > 0) {
                            const fileId = items[0].url.replace("gdrive:", "");
                            this.setState({ gdriveVideoFileId: fileId, gdriveVideoFileName: items[0].name });
                          }
                        }}
                      />
                    )}
                  </div>
                )}

                {["Audio"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">Source</span>
                    <div className="hi-btn-row">
                      <button
                        className={"hi-btn" + (this.state.audioSource === "url" ? " hi-btn-active" : "")}
                        onClick={() => this.setState({ audioSource: "url" })}
                      >
                        URL
                      </button>
                      <button
                        className={"hi-btn" + (this.state.audioSource === "gdrive" ? " hi-btn-active" : "")}
                        onClick={() => this.setState({ audioSource: "gdrive" })}
                      >
                        Google Drive
                      </button>
                    </div>
                  </div>
                )}

                {["Audio"].includes(this.state.insertType) && this.state.audioSource === "url" && (
                  <div className="hi-field">
                    <span className="hi-label">URL</span>
                    <textarea
                      className="hi-textarea"
                      rows={4}
                      onChange={this.handleChangeMediaURL}
                      placeholder="Paste audio URL here"
                    />
                  </div>
                )}

                {["Audio"].includes(this.state.insertType) && this.state.audioSource === "gdrive" && (
                  <div className="hi-field">
                    {this.state.gdriveAudioFileId ? (
                      <div className="hi-btn-row">
                        <span className="hi-value" style={{ flex: 1 }}>{this.state.gdriveAudioFileName}</span>
                        <button
                          className="hi-btn"
                          onClick={() => this.setState({ gdriveAudioFileId: "", gdriveAudioFileName: "" })}
                        >
                          Change
                        </button>
                      </div>
                    ) : (
                      <GoogleDrivePicker
                        fileType="audio"
                        onSelect={(items) => {
                          if (items.length > 0) {
                            const fileId = items[0].url.replace("gdrive:", "");
                            this.setState({ gdriveAudioFileId: fileId, gdriveAudioFileName: items[0].name });
                          }
                        }}
                      />
                    )}
                  </div>
                )}

                {["HTML"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">HTML</span>
                    <textarea
                      className="hi-textarea"
                      rows={6}
                      onChange={this.handleChangeHTML}
                      placeholder="Enter HTML"
                    />
                  </div>
                )}

                {["Image"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">Image</span>
                    <div className="hi-btn-row">
                      <button className="hi-btn" onClick={() => this.selectImage()}>
                        <FontAwesomeIcon icon={solid("image")} className="hi-btn-icon" />
                        Select Image
                      </button>
                      <button className="hi-btn" onClick={() => this.getImageURL()}>
                        <FontAwesomeIcon icon={solid("link")} className="hi-btn-icon" />
                        Enter URL
                      </button>
                    </div>
                    <div className="hi-image-preview">
                      {this.state.imageURL
                        ? <img src={this.state.imageURL} alt="" />
                        : <span className="hi-image-preview-empty">No image selected</span>
                      }
                    </div>
                  </div>
                )}

                {["Image"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">Width</span>
                    <div className="hi-btn-row">
                      <button className="hi-btn" onClick={() => this.selectImageWidth()}>
                        <FontAwesomeIcon icon={solid("arrows-left-right")} className="hi-btn-icon" />
                        Select Width
                      </button>
                    </div>
                    <div className="hi-value">{this.state.imageSize}px</div>
                  </div>
                )}

                {(["Itinerary"].includes(this.state.insertType) ||
                  (["Map", "Map with Places List", "Places List"].includes(this.state.insertType) && this.state.ScheduleFilter)) && (
                  <div className="hi-field">
                    <span className="hi-label">Schedule</span>
                    <div className="hi-btn-row">
                      <button className="hi-btn" onClick={() => this.selectItinerary("uni")}>
                        <FontAwesomeIcon icon={solid("calendar")} className="hi-btn-icon" />
                        Select Schedule
                      </button>
                    </div>
                    {this.state.itineraryName && <div className="hi-value">{this.state.itineraryName}</div>}
                  </div>
                )}

                {["Section"].includes(this.state.insertType) && (
                  <div className="hi-field">
                    <span className="hi-label">Section</span>
                    <div className="hi-btn-row">
                      <button className="hi-btn" onClick={() => this.selectSection()}>
                        <FontAwesomeIcon icon={solid("list")} className="hi-btn-icon" />
                        Select Section
                      </button>
                    </div>
                    {this.state.sectionName && <div className="hi-value">{this.state.sectionName}</div>}
                  </div>
                )}

                {["Map", "Map with Places List", "Places List"].includes(this.state.insertType) && this.state.DayFilter && (
                  <div className="hi-field">
                    <span className="hi-label">Day</span>
                    <div className="hi-btn-row">
                      <button className="hi-btn" onClick={() => this.selectDay()}>
                        <FontAwesomeIcon icon={solid("calendar-day")} className="hi-btn-icon" />
                        Select Day
                      </button>
                    </div>
                    {this.state.day && <div className="hi-value">{this.state.day}</div>}
                  </div>
                )}

                {["Map", "Map with Places List", "Places List"].includes(this.state.insertType) && (
                  <>
                    <div className="hi-field">
                      <span className="hi-label">Places</span>
                      <div className="hi-btn-row">
                        <button className="hi-btn" onClick={() => this.selectPlaces()}>
                          <FontAwesomeIcon icon={solid("map-pin")} className="hi-btn-icon" />
                          Select Places
                        </button>
                      </div>
                      {this.state.Places.length > 0 && <div className="hi-value">{this.displayValueList(this.state.Places)}</div>}
                    </div>
                    <div className="hi-field">
                      <span className="hi-label">Groups</span>
                      <div className="hi-btn-row">
                        <button className="hi-btn" onClick={() => this.selectGroups("multi")}>
                          <FontAwesomeIcon icon={solid("layer-group")} className="hi-btn-icon" />
                          Select Groups
                        </button>
                      </div>
                      {this.state.Groups.length > 0 && <div className="hi-value">{this.displayValueList(this.state.Groups)}</div>}
                    </div>
                    <div className="hi-field">
                      <span className="hi-label">Categories</span>
                      <div className="hi-btn-row">
                        <button className="hi-btn" onClick={() => this.selectCategories("multi")}>
                          <FontAwesomeIcon icon={solid("tags")} className="hi-btn-icon" />
                          Select Categories
                        </button>
                      </div>
                      {this.state.Categories.length > 0 && <div className="hi-value">{this.displayValueList(this.state.Categories)}</div>}
                    </div>
                  </>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />

        <SectionsDialog
          show={this.state.SectionsDialogShow}
          onHide={() => this.setState({ SectionsDialogShow: false })}
          update_display={this.UpdateDisplay}
          mode={"select"}
          callback={this.selectSectionCallback}
        />
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
          area={true}
        />
      </div>
    );
  }
}
export default HTMLInserDialog;
